import {createMuiTheme} from '@material-ui/core/styles'

const theme = createMuiTheme({
	pallete: {
	}
})

export default theme